import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Spinner,
  Button,
} from "@chakra-ui/react";
import { StarIcon } from "@chakra-ui/icons";
import moment from "moment";

const FeedbackList = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchFeedbacks = useCallback(
    async (loadMore = false) => {
      if (loadMore) {
        setLoadingMore(true);
      } else {
        setLoading(true);
      }

      try {
        const response = await axios.get(
          `https://backend-my-portfolio.onrender.com/api/feedback?page=${page}&limit=10`
        );
        if (response.data.length > 0) {
          setFeedbacks((prevFeedbacks) => [...prevFeedbacks, ...response.data]);
          setHasMore(response.data.length === 10);
          setPage((prevPage) => prevPage + 1);
        } else {
          setHasMore(false);
        }
      } catch (error) {
        console.error("Erro ao buscar feedbacks:", error);
      } finally {
        if (loadMore) {
          setLoadingMore(false);
        } else {
          setLoading(false);
        }
      }
    },
    [page]
  );

  useEffect(() => {
    fetchFeedbacks();
  }, [fetchFeedbacks]);

  const handleLoadMore = () => {
    fetchFeedbacks(true);
  };

  return (
    <Container maxW="container.xl" py={10}>
      <Heading mb={6}>Feedbacks Recebidos</Heading>
      <VStack spacing={4} align="stretch">
        {feedbacks.map((feedback) => (
          <Box key={feedback._id} p={5} shadow="md" borderWidth="1px">
            <Heading fontSize="xl">{feedback.name}</Heading>
            <HStack>
              {[...Array(5)].map((_, i) => (
                <StarIcon
                  key={i}
                  color={i < feedback.rating ? "yellow.400" : "gray.300"}
                />
              ))}
            </HStack>
            <Text mt={4}>{feedback.feedback}</Text>
            <Text fontSize="sm" color="gray.500">
              {moment(feedback.createdAt).format("LLL")}
            </Text>
          </Box>
        ))}
      </VStack>
      {loading && <Spinner />}
      {hasMore && !loading && (
        <Button onClick={handleLoadMore} mt={4}>
          Carregar Mais
        </Button>
      )}
      {loadingMore && <Spinner />}
    </Container>
  );
};

export default FeedbackList;
